// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS208: Avoid top-level this
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
class ChatController {
   $scope: any
   alerts: any
   chat: any
   chatScope: any
   locale: any
   translationService: any
   constructor($scope: any, chat: any, alerts: any, locale: any, translationService: any) {
      // set up scope
      this.switchView = this.switchView.bind(this)
      this.email = this.email.bind(this)
      this.close = this.close.bind(this)
      this.toggleCollapse = this.toggleCollapse.bind(this)
      this.$scope = $scope
      this.chat = chat
      this.alerts = alerts
      this.locale = locale
      this.translationService = translationService
      this.$scope.chat = (this.chatScope = this.chat.scope.chat)
      this.$scope.chatView = ''
      this.$scope.collapsed = false
      this.$scope.alerts = this.alerts.alerts
      this.$scope.isSending = false
      this.chatScope.visible = false
      this.$scope.isRTL = this.locale.localization.isRTL

      // methods
      this.$scope.email = this.email
      this.$scope.switchView = this.switchView
      this.$scope.toggleCollapse = this.toggleCollapse
      this.$scope.closeWidget = this.close
   }

   switchView(view: any) {
      return this.$scope.chatView = view
   }

   email() {
      this.alerts.resetAlert('chatEmailError')
      if (!this.$scope.isSending) {
         this.$scope.isSending = true
         return this.chat.email({
            replyTo: this.$scope.from,
            message: `Message from: ${this.$scope.from}\n\n${this.$scope.message}`,
            sendCopy: this.$scope.sendCopy
         }).then(
            // success
            () => {
               this.alerts.pulseAlert('emailNotify', this.translationService.translations.EMAIL_SENT_SUCCESSFULLY)
               this.$scope.from = ""
               this.$scope.message = ""
               return this.$scope.sendCopy = false
            }
            ,
            // error
            () => this.alerts.setAlert('chatEmailError', this.translationService.translations.EMAIL_PROCESSING_ERROR)
         ).finally(
            () => { return this.$scope.isSending = false
            })
      }
   }

   close() {
      this.$scope.collapsed = false
      return this.chatScope.visible = false
   }

   toggleCollapse() {
      return this.$scope.collapsed = !this.$scope.collapsed
   }
}

ChatController.$inject = ['$scope', 'chatService', 'alertService', 'localizationService', 'translationService']

angular.module('summonApp.controllers')
   .controller('ChatCtrl', ChatController)
